import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import {Translate} from "../../../../config/Translate";
import axios from "axios";
import {defaultVariabls} from "../../../../config";
import {connect} from "trim-redux";
import withWidth from "@material-ui/core/withWidth/withWidth";
import {withSnackbar} from "notistack";
import {withRouter} from "react-router";
import {DialogActions, ListItem, TableContainer, withStyles} from "@material-ui/core";
import {Styles} from "../../../../config/design/styles";
import CloseRoundedIcon from '@material-ui/icons/CloseRounded';
import IconButton from "@material-ui/core/IconButton/IconButton";
import Grid from "@material-ui/core/Grid/Grid";
import LoadingButton from "../../../components/elements/LoadingButton";

import GetAppTwoToneIcon from '@material-ui/icons/GetAppTwoTone';
import Typography from "@material-ui/core/Typography/Typography";
import SingleFileChooser from "../../fileManager/Components/SingleFileChooser";
import CloudDownloadRoundedIcon from '@material-ui/icons/CloudDownloadRounded';
import Alert from "@material-ui/lab/Alert/Alert";
import AlertTitle from "@material-ui/lab/AlertTitle/AlertTitle";
import {updateRedux} from "../../../../config/Security";
import ContactSupportRoundedIcon from '@material-ui/icons/ContactSupportRounded';
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import TableBody from "@material-ui/core/TableBody";
import LoadingButtonWithConfirmation from "../../../components/elements/LoadingButtonWithConfirmation";
import CheckBoxRoundedIcon from '@material-ui/icons/CheckBoxRounded';
import BackupRoundedIcon from '@material-ui/icons/BackupRounded';
import Tooltip from "@material-ui/core/Tooltip/Tooltip";
import HelpOutlineRoundedIcon from '@material-ui/icons/HelpOutlineRounded';
import List from "@material-ui/core/List/List";
import ListItemText from "@material-ui/core/ListItemText/ListItemText";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction/ListItemSecondaryAction";
class RentHelpIcon extends React.Component{
    state = {
        open:false,

    };
    toggleOpen(){
        this.setState({
            open: !this.state.open,
        })
    }

    render(){
        let {open} = this.state;
        return (
            <>
                <Tooltip  title={Translate.rentHelpText}>
                    <IconButton
                        size="small"
                        color="secondary"
                        onClick={() => this.toggleOpen()}
                    >
                        <HelpOutlineRoundedIcon fontSize="small" color="secondary"/>
                    </IconButton>
                </Tooltip>

                <Dialog
                    open={open}
                    onClose={() => this.toggleOpen()}
                    aria-labelledby="form-dialog-title"
                    fullWidth
                    maxWidth="xs"
                >
                    <DialogTitle id="form-dialog-title">
                        <IconButton
                            onClick={() => this.toggleOpen()}
                            style={{position:"absolute",left:15,top:15}}
                            size="small"
                        >
                            <CloseRoundedIcon fontSize="small"/>
                        </IconButton>
                        {Translate.rentHelpText}
                    </DialogTitle>
                    <DialogContent style={{minHeight:140}}>
                        <Typography>{Translate.rentHelpTextDesc}</Typography>
                        <List>
                            {
                                this.props.setting.rents.map((item,index) => (
                                    <ListItem kwy={index}>
                                        <ListItemText
                                            primary={item.name}
                                        />
                                        <ListItemSecondaryAction>
                                            %{item.percent}
                                        </ListItemSecondaryAction>
                                    </ListItem>

                                ))
                            }
                        </List>
                    </DialogContent>
                </Dialog>
            </>
        );
    }
}
const mstp = state => ({
    setting: state.setting,
});
export default withWidth()(withSnackbar(withRouter(withStyles(Styles)(connect(mstp)(RentHelpIcon)))));